import Model from './Model'
export default class Supplier extends Model {

    resource()
    {
        return 'suppliers'
    }
}
